import "./Wire.css";

import { useRef } from "react";
import { useSharedState } from "./app/useSharedState";
import { TWireID } from "./Scene";

type TProps = {};

const WIRE_TANGENT_LENGTH = 24;
const WIRE_HITBOX_START = 12;
const WIRE_HITBOX_LENGTH = 24;

export function Wire({
  points: [ax, ay, bx, by],
  pathId,
  wireId,
}: {
  points: [number, number, number, number];
  pathId: string;
  wireId?: TWireID;
}) {
  const [scene] = useSharedState("scene");
  const [holdingState, setHoldingState] = useSharedState("holdingState");
  const pathRef = useRef<SVGPathElement>(null);

  let handles = null;
  if (wireId !== undefined && pathRef.current !== null) {
    const wire = scene.wires[wireId];

    const pathLength = pathRef.current.getTotalLength();
    const spaceBetween =
      pathLength - (WIRE_HITBOX_START + WIRE_HITBOX_LENGTH) * 2;
    const shrinkHandles = spaceBetween < 0;

    const startHitboxStart =
      pathRef.current.getPointAtLength(WIRE_HITBOX_START);
    const startHitboxEnd = pathRef.current.getPointAtLength(
      shrinkHandles ? pathLength / 2 : WIRE_HITBOX_START + WIRE_HITBOX_LENGTH
    );
    const endHitboxStart = pathRef.current.getPointAtLength(
      pathLength - WIRE_HITBOX_START
    );
    const endHitboxEnd = pathRef.current.getPointAtLength(
      shrinkHandles
        ? pathLength / 2
        : pathLength - WIRE_HITBOX_START - WIRE_HITBOX_LENGTH
    );

    handles = [
      <path
        className="wirecanvaswires-wire-handle-start"
        d={`M ${startHitboxStart.x} ${startHitboxStart.y} L ${startHitboxEnd.x} ${startHitboxEnd.y}`}
        onPointerUp={(e) => {
          // setHoldingState({
          //   type: "edit_wire",
          //   existingId: wireId,
          //   start: null,
          //   end: wire.end,
          // });
        }}
      />,
      <path
        className="wirecanvaswires-wire-handle-end"
        d={`M ${endHitboxStart.x} ${endHitboxStart.y} L ${endHitboxEnd.x} ${endHitboxEnd.y}`}
        onPointerUp={(e) => {
          // setHoldingState({
          //   type: "edit_wire",
          //   existingId: wireId,
          //   start: wire.start,
          //   end: null,
          // });
        }}
      />,
    ];
  }

  ay += 0.5;
  by += 0.5;

  return (
    <svg
      className="wire material-symbols-sharp"
      opacity={
        holdingState?.type === "edit_wire" &&
        holdingState.existingId !== undefined &&
        holdingState.existingId === wireId
          ? 0.5
          : undefined
      }
    >
      <path
        ref={pathRef}
        id={pathId}
        className="wire-path"
        d={`M ${ax} ${ay} C ${ax + WIRE_TANGENT_LENGTH} ${ay}, ${
          bx - WIRE_TANGENT_LENGTH
        } ${by}, ${bx} ${by}`}
      />
      {handles}
      <text fill="black">
        <textPath href={"#" + pathId} alignmentBaseline="central">
          arrow_right
        </textPath>
        <textPath
          href={"#" + pathId}
          alignmentBaseline="central"
          textAnchor="end"
          startOffset="100%"
        >
          arrow_right
        </textPath>
      </text>
    </svg>
  );
}
